<template>
  <div class="c-base-checkbox">
    <base-icon
      v-if="checked"
      class="c-base-checkbox__icon has-text-black"
      width="26"
      height="26"
      name="painel/checkbox-checked-icon"
    />
    <base-icon
      v-else
      class="c-base-checkbox__icon has-text-black"
      width="26"
      height="26"
      name="painel/checkbox-unchecked-icon"
    />
  </div>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.checkbox {
  display: inline-flex;
  align-items: center;
}
.c-base-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  &__icon {
    margin-right: 0.5em;
  }
}
</style>
